import { formatDateTime, formatMoney, formatNumber, localeOf } from './i18n.js';
const language = () => typeof document !== 'undefined' ? document.documentElement.lang : 'ar';
const TOKEN_KEY = 'bait_henna_session_v1';

export const session = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (token) => localStorage.setItem(TOKEN_KEY, token),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

export async function api(path, options = {}) {
  const headers = { ...(options.body ? { 'Content-Type':'application/json' } : {}), ...options.headers };
  const token = session.get();
  if (token) headers.Authorization = `Bearer ${token}`;
  const response = await fetch(`/api${path}`, { ...options, headers, body: options.body && typeof options.body !== 'string' ? JSON.stringify(options.body) : options.body });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    if (response.status === 401) session.clear();
    const error = new Error(data.error || 'تعذر إكمال الطلب');
    error.code = data.errorCode || (!data.error ? 'requestFailed' : undefined);
    error.params = data.errorParams || {};
    throw error;
  }
  return data;
}

export const sar = value => formatMoney(language(),value);
export const number = value => formatNumber(language(),value);
export const dateTime = value => formatDateTime(language(),value);
export const dateOnly = value => value ? new Intl.DateTimeFormat(localeOf(language()), {dateStyle:'medium',timeZone:'UTC'}).format(new Date(`${value}T12:00:00Z`)) : '—';

// التطبيع العربي يعيش في server/arabic.mjs ليكون مصدراً واحداً للواجهة والخادم:
// بحث الكاشير ومطابقة فواتير الموردين يجب أن يريا الاسم نفسه بالطريقة نفسها.
export { normalizeArabic } from '../../server/arabic.mjs';
